import { AcquisitionType } from '@avantstay/arriere-clients/dist/arriereBackoffice'

export const labelByAcquisitionType: Record<string, string> = {
  [AcquisitionType.externalPropertyManagementCompany]: 'External Property Management Company',
  [AcquisitionType.organic]: 'Organic Onboard',
  [AcquisitionType.otaSyncIssue]: 'OTA Sync Issue',
  [AcquisitionType.portfolio]: 'Portfolio Acquisition (M&A)',
  [AcquisitionType.unconnectedOta]: 'Unconnected OTA',
  [AcquisitionType.undefined]: 'Undefined',
}
